import { LOG_LEVEL } from "./logLevel";
export default {
    [LOG_LEVEL.DEBUG]: "text-light-on-surface-variant bg-light-blue-2",
    [LOG_LEVEL.ERROR]: "text-sys-light-on-error-container bg-state-layers-light-error-container-solid",
    [LOG_LEVEL.INFO]: "text-light-on-surface-variant bg-state-layers-light-on-secondary-container-opacity-8",
    [LOG_LEVEL.WARNING]: "text-on-light-yellow bg-light-yellow"
};
